<template>
  <div class="main-container">
    <div class="approval-tree" v-if="mainForm.editFlag == 'view' && costProcessList && costProcessList.length">
      <approval-tree :list="costProcessList" :no-his-list="costProcessNoHisList"></approval-tree>
    </div>
    <div class="gridHead">
      <el-form ref="mainForm" :model="mainForm" :rules="rules" style="width: 100%;" label-width="120px" @submit.native.prevent>
        <bsp-collapsible-module :title="$t('cost.cost024')" :content-style="contentStyle" :clickable="false" v-show="mainForm.editFlag != 'view'"><!-- 选择付款单类型 -->
          <el-row>
            <el-col :span="24">
              <el-form-item class="form-item-content-auto">
                <el-radio-group v-model="mainForm.costType" ref="costTypeRadio" @change="costTypeChange" v-if="initDataForm.costTypeList && initDataForm.costTypeList.length">
                  <el-radio v-model="mainForm.costType" :label="costTypeBO.COST_TYPE" v-for="costTypeBO in initDataForm.costTypeList" :key="costTypeBO.COST_TYPE">{{costTypeBO.DEFINED_NAME}}</el-radio>
                </el-radio-group>
                <div v-show="costTypeList.length == 0" style="color: #999;">{{$t('cost.cost025')}}</div><!-- 无报销类型，请检查！ -->
              </el-form-item>
            </el-col>
          </el-row>
        </bsp-collapsible-module>
        <bsp-collapsible-module :title="$t('cost.cost026')" :content-style="contentStyle" :clickable="false"><!-- 付款单信息 -->
          <el-row v-show="mainForm.costType == '30030003'">
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost027')" prop="isContract"><!-- 是否合同支付 -->
                <el-checkbox v-model="isContractBoolean" :disabled="mainForm.editFlag == 'view'"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="mainForm.costType == '30030003' && isContractBoolean">
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost028')" prop="supplierId"><!-- 供应商 -->
                <bsp-dicts-select v-model="mainForm.supplierId" :select-value.sync="mainForm.supplierId" :options-list="cusSupplierForContractList" @selectChange="supplierIdChange"  :disabled="mainForm.editFlag == 'view'"></bsp-dicts-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="supplierContractFlag">
              <el-form-item :label="$t('cost.cost029')" prop="constractId"><!-- 合同编号 -->
                <div class="form-item-flex">
                  <bsp-dicts-select class="form-item-flex-1" v-model="mainForm.constractId" :select-value.sync="mainForm.constractId" :options-list="constractIdList" @selectChange="constractIdChange" :disabled="mainForm.editFlag == 'view'"></bsp-dicts-select>
                  <el-link type="primary" @click="viewConstract" :disabled="!mainForm.constractId">{{$t('cost.cost040')}}</el-link><!-- 查看 -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="supplierContractFlag">
              <el-form-item :label="$t('cost.cost030')" prop="invoiceDate"><!-- 开票日期 -->
                <el-date-picker v-model="mainForm.invoiceDate" type="date" value-format='yyyy-MM-dd'  @change="invoiceDateChange" :disabled="mainForm.editFlag == 'view'"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost031')" prop="applierId"><!-- 报销人 -->
                <!--              <bsp-dicts-select v-model="mainForm.applierId" :select-value.sync="mainForm.applierId" dic-num="8052" @selectChange="applierIdChange"  ></bsp-dicts-select>-->
                <bsp-select-tree v-model="mainForm.applierId" :select-value.sync="mainForm.applierId" :options-list="applierList" codeItemId="id" codeItemName="name" @selectChange="applierIdChange" :disabled="mainForm.editFlag == 'view'"></bsp-select-tree>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost032')"><!-- 部门 -->
                <el-input v-model="mainForm.deptName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost033')" prop="assistProject"><!--项目组 -->
                <bsp-dicts-select v-model="mainForm.assistProject" :select-value.sync="mainForm.assistProject" :options-list="assistProjectList"    :disabled="mainForm.editFlag == 'view'"></bsp-dicts-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="mainForm.costType != '30030003'">
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost034')" prop="payeeName"><!-- 收款方-个人 -->
                <bsp-dicts-select v-model="mainForm.payeeName" :select-value.sync="mainForm.payeeName" :options-list="personPayeeList" @selectChange="payeeNameChange"   :disabled="mainForm.editFlag == 'view'"></bsp-dicts-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="mainForm.costType == '30030001'">
              <el-form-item :label="$t('cost.cost035')" prop="applicationId"><!-- 差旅编号 -->
                <!--              <bsp-dicts-select v-model="mainForm.applicationId" :select-value.sync="mainForm.applicationId" :options-list="travelApplicationList"    ></bsp-dicts-select>-->

                <el-select v-model="mainForm.applicationId"  :disabled="mainForm.editFlag == 'view'">
                  <el-option
                    v-for="item in travelApplicationList"
                    :key="item.id"
                    :label="item.travelCode"
                    :value="item.id">
                    <span style="float: left">{{ item.travelTheme }}({{ item.travelCode }})</span>
                    <!--                  <span style="float: right; color: #8492a6; font-size: 13px"></span>-->
                  </el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-row>
          <el-row v-if="mainForm.costType == '30030003'">
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost036')" prop="sourceId"><!-- 收款方-供应商 -->
                <bsp-dicts-select v-model="mainForm.sourceId" :select-value.sync="mainForm.sourceId" :options-list="sourceIdList" @selectChange="sourceIdChange"   :disabled="mainForm.editFlag == 'view'"></bsp-dicts-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost037')" prop="payType"><!-- 支付方式 -->
                <bsp-dicts-select v-model="mainForm.payType" :select-value.sync="mainForm.payType" dic-num="3020"   :disabled="mainForm.editFlag == 'view'"></bsp-dicts-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost038')" prop="payeeAccountId" v-show="mainForm.payType != '30200010'"><!-- 银行账号 -->
                <div class="form-item-flex">
                  <el-select class="form-item-flex-1" v-model="mainForm.payeeAccountId" :disabled="mainForm.editFlag == 'view'">
                    <el-option
                      v-for="item in payeeAccountList"
                      :key="item.codeItemId"
                      :label="item.codeItemName"
                      :value="item.codeItemId">
                      <span style="float: left">{{ item.bankName }}({{ item.codeItemName }})</span>
                      <!--                  <span style="float: right; color: #8492a6; font-size: 13px"></span>-->
                    </el-option>
                  </el-select>
                  <el-link type="primary" v-show="mainForm.editFlag != 'view'" @click="accountManage">{{$t('cost.cost039')}}</el-link><!-- 维护银行账号 -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost041')" prop="contact"><!-- 联系方式 -->
                <el-input v-model="mainForm.contact" placeholder="" @blur="contactChange" :disabled="mainForm.editFlag == 'view'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="false">
            <el-col :span="8">
              <el-form-item label="票据张数" prop="billNum">
                <el-input-number v-model="mainForm.billNum"  controls="true" precision="0" placeholder="票据张数" max="1000" min="0"  :disabled="mainForm.editFlag == 'view'"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-row>

          <el-row v-show="initDataForm.costAttach == '00901'">
            <el-col :span="8">
              <el-form-item label="审核单附件" prop="costAttachIds">
                <el-tooltip :content="$t('cost.cost045')" placement="top"><!-- 附件 -->
                  <el-image
                    class="gridOptIcon"
                    :src="costAttachUploadFjUrl"
                    @click="uploadCostAttach()"
                  ></el-image>
                </el-tooltip>
                <el-tooltip :content="$t('cost.cost113')" placement="top"><!-- 删除附件 -->
                  <el-image
                    class="gridOptIcon"
                    :src="costAttachDeleteUrl"
                    @click="deleteCostAttach()"
                    v-show="mainForm.editFlag != 'view'"
                  ></el-image>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="8">
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-row>
        </bsp-collapsible-module>
        <bsp-collapsible-module :title="$t('cost.cost042')" :content-style="contentStyle" :clickable="false"><!-- 费用信息 -->
          <template slot="operation">
            <el-button type="text" @click.stop="pickInvoice" v-show="mainForm.editFlag != 'view'">{{$t('cost.cost043')}}</el-button><!-- 从发票夹选择 -->
          </template>
          <bsp-grid
            :demoLoading.sync="demoLoading"
            :tableColumns.sync="tableColumns"
            :tableDatas.sync="costDetailList"
          >
            <template v-slot:projectName="{ row }">
              <el-link :underline="false" :type="row.projectName? 'primary' : 'default'" @click="selectProject(row)" :disabled="mainForm.editFlag == 'view'">{{ row.projectName? row.projectName : '（请选择）'}}</el-link>
            </template>
            <template v-slot:fmoney="{ row }">
              <span v-show="row.currency != '10091001'">{{row.fmoney}}</span>
              <span v-show="row.currency == '10091001'">{{row.includeTax}}</span>
            </template>
            <template v-slot:billNo="{ row }">
              <el-input v-model="row.billNo" readonly :disabled="mainForm.editFlag == 'view'" clearable></el-input>
            </template>
            <template v-slot:remark="{ row }">
              <el-input v-model="row.remark" :disabled="mainForm.editFlag == 'view'" clearable></el-input>
            </template>
            <template v-slot:operation="{ row, rowIndex }">
              <el-tooltip :content="$t('cost.cost044')" placement="top"><!-- 分摊 -->
                <el-image
                  class="gridOptIcon"
                  :src="row.btnShareUrl"
                  @click="shareCostDetail(row, rowIndex)"
                  @mouseenter="MM_swapImage(row,'share', 'enter')"
                  @mouseleave="MM_swapImage(row,'share', 'leave')"
                  v-show="mainForm.editFlag != 'view' || (mainForm.editFlag == 'view' && row.shareBtnFlag)"
                ></el-image>
              </el-tooltip>
              <el-tooltip :content="$t('cost.cost045')" placement="top"><!-- 附件 -->
                <el-image
                  class="gridOptIcon"
                  :src="row.btnUploadFjUrl"
                  @click="uploadAttachCostDetail(row, rowIndex)"
                  @mouseenter="MM_swapImage(row,'upload', 'enter')"
                  @mouseleave="MM_swapImage(row,'upload', 'leave')"
                ></el-image>
              </el-tooltip>
              <el-tooltip :content="$t('cost.cost046')" placement="top"><!-- 删除行 -->
                <el-image
                  class="gridOptIcon"
                  :src="row.btnDeleteUrl"
                  @click="deleteCostDetail(row, rowIndex)"
                  @mouseenter="MM_swapImage(row,'delete', 'enter')"
                  @mouseleave="MM_swapImage(row,'delete', 'leave')"
                  v-show="mainForm.editFlag != 'view'"
                ></el-image>
              </el-tooltip>
              <el-tooltip :content="$t('cost.cost047')" placement="top"><!-- 异常 -->
                <el-image
                  class="gridOptIcon"
                  :src="row.btnWarnUrl"
                  @click="showWarn(row, rowIndex)"
                  @mouseenter="MM_swapImage(row,'warn', 'enter')"
                  @mouseleave="MM_swapImage(row,'warn', 'leave')"
                  v-show="row.warnMsg"
                ></el-image>
              </el-tooltip>
            </template>
          </bsp-grid>

          <el-row class="costDetailRow marginTop20" v-show="mainForm.constractId">
            <el-col :span="3" class="costDetailHeader">
              {{$t('cost.cost048')}}<!-- 合同总额 -->
            </el-col>
            <el-col :span="3" class="costDetailHeader">
              {{$t('cost.cost049')}}<!-- 总金额不超过 -->
            </el-col>
            <el-col :span="3" class="costDetailHeader">
              {{$t('cost.cost050')}}<!-- 已支付 -->
            </el-col>
            <el-col :span="6" class="costDetailHeader">
              {{$t('cost.cost051')}}<!-- 支付在途（不含本单） -->
            </el-col>
            <el-col :span="6" class="costDetailHeader">
              {{$t('cost.cost052')}}<!-- 支付次数（不含本单） -->
            </el-col>
            <el-col :span="3" class="costDetailHeader">
              {{$t('cost.cost053')}}<!-- 合同余额 -->
            </el-col>

          </el-row>
          <el-row class="costDetailRow" v-show="mainForm.constractId">
            <el-col :span="3" class="costDetailCol">
              {{contractInfo.contractAmount}}
            </el-col>
            <el-col :span="3" class="costDetailCol">
              {{contractInfo.amountLimit}}
            </el-col>
            <el-col :span="3" class="costDetailCol">
              {{contractInfo.endTotalMoney}}
            </el-col>
            <el-col :span="6" class="costDetailCol">
              {{contractInfo.dzfTotalMoney}}
            </el-col>
            <el-col :span="6" class="costDetailCol">
              {{contractInfo.payTimes}}
            </el-col>
            <el-col :span="3" class="costDetailCol">
              {{contractInfo.remainingSum}}
            </el-col>

          </el-row>

          <el-row class="marginTop10">
            <el-col :span="24" style="text-align: right;">
              {{$t('cost.cost054')}}<!-- 报销合计 --><span class="coler_red font_b24">{{totalMoneyAll}}</span>{{$t('cost.cost061')}}<!-- 元 -->
            </el-col>
          </el-row>
        </bsp-collapsible-module>

        <bsp-collapsible-module :title="$t('cost.cost055')" :content-style="contentStyle" :clickable="false" v-show="borrowList.length > 0"><!-- 借款信息 -->
          <template slot="operation">
          </template>
          <bsp-grid
            ref="borrowListTable"
            :demoLoading.sync="demoLoading"
            :tableColumns.sync="borrowColumns"
            :tableDatas.sync="borrowList"
            @checkbox-all="selectAllEvent"
            @checkbox-change="selectChangeEvent"
          >
            <template v-slot:remainingAmount="{ row }">
              <el-input-number v-model="row.hedgebro" precision="2" min="-0.001" max="999999999.001" @change="hedgebroChange(row)" style="width:30%;" :disabled="!row.checked || initDataForm.loanLimitSwitch == '00901' || mainForm.editFlag == 'view'"></el-input-number> &nbsp;/&nbsp; {{row.remainingAmount}}
            </template>
          </bsp-grid>
          <el-row class="marginTop10">
            <el-col :span="24" style="text-align: right;">
              {{$t('cost.cost056')}}<!-- 冲借款金额 --><span class="coler_red font_b24">{{totalBorrowMoney}}</span>{{$t('cost.cost061')}}<!-- 元 -->
            </el-col>
          </el-row>
        </bsp-collapsible-module>

        <el-row class="marginTop20">
          <el-col :span="24" v-for="(customItem, index) in initDataForm.customItems" :key="index">
            <el-form-item :label="customItem.name" class="form-item-content-auto">
              <el-input type="textarea" v-model="mainForm[customItem.assCostItem]" :disabled="mainForm.editFlag == 'view'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="marginTop10">
          <el-col :span="24" style="text-align: right;">
            {{$t('cost.cost057')}}<!-- 付款合计 --><span class="coler_red font_b24">{{totalMoneyLower}}</span>{{$t('cost.cost061')}}<!-- 元 -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 没有实质的用处，解决页面不刷新-->
    <div v-show="false">
      <div v-for="ff in fileListRefresh" :key="ff">{{ff}}</div>
    </div>

    <pick-invoice class="pickInvoice" ref="pickInvoice" @reload="pickInvoiceSubmit"></pick-invoice>

    <preview-cost-process class="previewCostProcess" ref="previewCostProcess" @reload="previewCostProcessSubmit"></preview-cost-process>

    <upload-attach ref="uploadAttach" @reload="doUploadSubmit"></upload-attach>

    <upload-attach ref="uploadCostAttach" @reload="doUploadCostSubmit"></upload-attach>

    <share-info ref="ShareInfo" class="ShareInfo" @reload="doShareSubmit"></share-info>

    <project-select ref="projectSelect" class="projectSelect" @reload="doProjectSubmit"></project-select>

    <dialog-iframe ref="DialogIframe" class="dialogIframe" @reload="doDialogIframeClose"></dialog-iframe>



    <page-footer>
      <el-button type="default" @click="handleGoBack">{{$t('cost.cost058')}}</el-button><!-- 取 消 -->
      <el-button type="default" @click="submitForm('draft')" :loading="loading" v-show="mainForm.editFlag != 'view'">{{$t('cost.cost059')}}</el-button><!-- 存草稿 -->
      <el-button type="primary" @click="submitForm('saveFirst')" :loading="loading" v-show="mainForm.editFlag != 'view'">{{$t('cost.cost060')}}</el-button><!-- 提 交 -->
    </page-footer>
  </div>
</template>

<script>
import btn_delete from "@/assets/img/btn_delete.gif"
import btn_delete_on from "@/assets/img/btn_delete_on.gif"
import btn_share from "@/assets/img/btn_share.png"
import btn_share_on from "@/assets/img/btn_share_on.png"
import btn_upload_fj from "@/assets/img/btn_upload_fj.png"
import btn_upload_fj_on from "@/assets/img/btn_upload_fj_on.png"
import btn_warn from "@/assets/img/btn_warn.png"
import BspDictsSelect from '@/components/bsp/bsp-dicts-select/bsp-dicts-select'
import BspSelectTree from '@/components/bsp/bsp-select-tree/bsp-select-tree'
import PickInvoice from '@/views/cost/components/PickInvoice'
import PreviewCostProcess from '@/views/cost/components/PreviewCostProcess'
import UploadAttach from "@/views/cost/components/UploadAttach";
import ShareInfo from "@/views/cost/components/ShareInfo";
import ProjectSelect from "@/views/cost/components/ProjectSelect";
import ApprovalTree from '@/views/cost/components/ApprovalTree'
import DialogIframe from "@/views/cost/components/DialogIframe";
import BspCollapsibleModule from '@/components/bsp/bsp-collapsible-module/bsp-collapsible-module'
import bspGrid from "@/components/bsp/bsp-grid/grid2";
import PageFooter from '@/components/bsp/page-footer/index'
import {mapGetters} from 'vuex';
import { base64Encode } from "@/util/endecode.js";
import {getDictsListBySetId} from '@/api/sys/code'
import { getNowFormatDate} from "@/util/date_format.js"
import { isvalidatemobile, cardid,validatenull,validatenumord,validatenum,validatename,validateEmail } from '@/util/validate';
import {
  getCloudCostStatusList,
  getCloudOrgPersonTree,
  getCloudCostEditInitData,
  getCloudDeptByPerId,
  getCloudTravelApplicationList,
  getCloudPersonPayee,
  getCloudPayeeAccount,
  getCloudBorrowListByPerId,
  getCloudJsonAssistProjectList,
  getCloudCusSupplierForContract,
  getCloudConstractInfoBySupplierIdAndPersonId,
  getCloudConstractInfoBySupplierId,
  getCloudConstractPaymentInfo,
  getCloudCusSupplierBySupplierId,
  getCloudCusSupplierPayeeId,
  getCloudCusSupplier,
  saveCostCloud,
  getCloudEditCostInfo,
  getViewCloudCostInfo,
} from "@/api/cost/cost";

import { uploadFile, downloadQiniuFile } from "@/api/sys/sys";
import { downloadFile, parseFloat2Round, accAdd, Subtr } from '@/util/util'
import { Message } from "element-ui";

export default {
  name: "costEdit",
  components: {BspDictsSelect, BspSelectTree, PickInvoice, PreviewCostProcess, UploadAttach, ShareInfo, ProjectSelect, ApprovalTree, BspCollapsibleModule,bspGrid, PageFooter, DialogIframe },
  data() {
    return {
      handlerOptParam:{},
      mainForm:{
        costType: '',
        deptId: '',
        deptName: '',
        payType: '30200001',
        isContract: '00900',//这个要根据isContractBoolean复制 true 00901
        supplierId: "",
        editFlag: "",
        payeeAccountId: '',
        applicationId: '',
      },
      pickInvoiceParams:{type:"cost"},
      userId:'', //用户id
      cdmId:"",
      optType: 'add', //页面操作类型

      from : "",
      parentFrom:"",
      tableDatas: [],
      opt:"add",//新增、编辑，目前为材质只支持新增
      searchParams: {},
      demoLoading: false,
      loadingImport: false,
      loadingBtn: false,
      receiptTypeReadonlyFlag: false,
      invoiceFile: {
        attachmentId: '',
        fileName: '',
      },
      costTypeList:[],//报销类型选择列表
      initDataForm:{},
      tableColumns: [],
      borrowColumns: [],
      costDetailList:[],
      applierList:[], //报销人选择列表
      assistProjectList:[], //报销项目组列表
      travelApplicationList:[], //差旅申请选择列表
      personPayeeList:[], //收款人列表
      payeeAccountList:[], //收款账号列表
      cusSupplierForContractList: [], //供应商
      sourceIdList: [], //收款方-供应商
      constractIdList: [], //合同列表
      contractInfo: {},
      isContractBoolean: false,
      supplierContractFlag: false,
      preUrl: process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL,
      totalMoneyAll: 0, //报销总额
      totalBorrowMoney: 0, //冲借款金额
      totalMoneyLower: 0,//付款总额
      borrowList: [], //借款列表
      multipleSelection: [],
      borrowInitFlag: true, //编辑场景下借款信息初始化用
      costAttachUploadFjUrl: btn_upload_fj,
      costAttachDeleteUrl: btn_delete,

      activeDetail: {},
      costProcessList: [],
      costProcessNoHisList: [],
      rules: {
        supplierId: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost028'), trigger: 'change' }//请选择供应商
        ],
        constractId: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost029'), trigger: 'change' }//请选择合同
        ],
        invoiceDate: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost030'), trigger: 'change' }//请选择开票日期
        ],
        applierId: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost031'), trigger: 'change' }//请选择报销人
        ],
        payeeName: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost034'), trigger: 'change' }//请选择收款方
        ],
        sourceId: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost036'), trigger: 'change' }//请选择收款方
        ],
        payType: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost037'), trigger: 'change' }//请选择支付方式
        ],
        payeeAccountId: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost038'), trigger: 'change' }//请选择银行账号
        ],
        contact: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.cost041'), trigger: 'blur' }//请填写联系方式
        ],
      },
      contentStyle: {
        'padding-top': '28px'
      }
    };
  },
  watch:{
    isContractBoolean(val){
      console.log("isContractBoolean", val)
      if(val){
        this.$set(this.mainForm, "isContract", "00901");
        this.$set(this.mainForm, "sourceId", null);
      }else{
        this.$set(this.mainForm, "isContract", "00900");
        this.$set(this.mainForm, "sourceId", null);
        this.$set(this.mainForm, "payeeId", null);
        this.$set(this.mainForm, "supplierId", null);
        this.$set(this.mainForm, "invoiceDate", null);
        this.$set(this.mainForm, "constractId", null);
        this.$set(this, "contractInfo", {});
        this.getCloudCusSupplier();


      }
    }
  },
  created() {
    //this.mainForm.editFlag = this.$route.query.editFlag;

    let lang = localStorage.getItem("lang") || 'zh';
    this.parmStr = "lang=" + base64Encode(lang) + "&accessToken=" + this.$store.getters.accessToken + "&aacode=invoice";

    if(this.$route.query.editFlag == 'add'){
      this.$set(this.mainForm, "editFlag", "add");
      this.getCloudCostEditInitData( this.mainForm.costType);
    }else if(this.$route.query.editFlag == 'edit'){
      this.getCloudEditCostInfo(this.$route.query.costId, this.$route.query.costStatus , this.$route.query.costType);
    }else if(this.$route.query.editFlag == 'view'){
      this.getViewCloudCostInfo(this.$route.query.costId, this.$route.query.costStatus);
    }

    this.getColumn();
    this.getBorrowColumn();

    //todo shipengchao 您所在的机构OCR识别可用次数不足10次，请联系对接客服经理进行配置
    //todo shipengchao  这个页面好像还有自定义说明项，最后看一下有没有人用，有的话就加上
    //todo shipengchao 补一下申请单附件的逻辑costAttachIds
    //todo shipengchao  checkRange出行费报销限制 checkContent
    //todo shipengchao projectFlag后续关注下这个属性用来实现小程序扫码上传的
    //todo shipengchao 保存2次后再删除，票夹状态没有变更
    //this.applierList = [{name:"部门1", value:"1", children: [{name:"张1", value:"11"},{name:"张2", value:"22"}]},{name:"部门2", value:"2" , children: [{name:"张3", value:"33"}]}];
  },
  mounted(){
    // console.log("批次号m",this.billBatch)
  },
  methods: {
    getColumn() {
      let column = [
        { type: "seq", width: "50px" },
        { title: this.$t('cost.invoice031'), field: "startDate", width: "8%" },//开始时间
        { title: this.$t('cost.invoice032'), field: "endDate", width: "8%" },//结束时间
        { title: this.$t('cost.invoice028'), field: "projectName", width: "8%", params:{ slot: 'projectName' } },//费用项目
        { title: this.$t('cost.invoice035'), field: "currencyTxt", width: "4%" },//币种
        { title: this.$t('cost.invoice036'), field: "exchangeRate", width: "4%" },//汇率
        { title: this.$t('cost.invoice038'), field: "fmoney", params:{ slot:'fmoney' }, width: "8%" },//含税金额
        { title: this.$t('cost.invoice037'), field: "includeTax", width: "8%" },//人民币金额
        { title: this.$t('cost.invoice048'), field: "vatTypeName", width: "8%" },//发票类型
        { title: this.$t('cost.invoice039'), field: "excludeTax", width: "8%" },//不含税金额
        { title: this.$t('cost.invoice040'), field: "vatMoney", width: "4%" },//税额
        { title: this.$t('cost.invoice047'), field: "billNo", width: "8%", params:{ slot:'billNo' } },//发票号码
        { title: this.$t('cost.invoice043'), field: "remark", width: "12%", params:{ slot:'remark' } },//备注
        { title: this.$t('cost.invoice013'), width: "8%", params:{ slot:'operation' }}//操作
      ];
      this.tableColumns = column
    },
    getBorrowColumn() {
      let column = [
        { type: "checkbox", setId:"", width: "50px", visible: this.initDataForm.loanLimitSwitch != '00901' && this.mainForm.editFlag != 'view' },
        { title: this.$t('cost.cost002'), field: "applyDate", width: "10%" },//申请日期
        { title: this.$t('cost.cost062'), field: "borrowTypeName", width: "10%" },//借款类型
        //{ title: "费用项目", field: "projectName", width: "8%", params:{ slot: 'projectName' } },
        { title: this.$t('cost.借款原因'), field: "borrowComment", width: "35%" },//借款原因
        { title: this.$t('cost.金额'), field: "remainingAmount", width: "40%", params:{ slot: 'remainingAmount' } },//金额
      ];
      this.borrowColumns = column
    },
    isCheckboxDisabled({ row }) {
      // 例如：role 为 'guest' 的用户不能手动勾选
      return false; // ✅ 只有 guest 可勾选？按需调整逻辑
      // 如果想全部只读，直接 return false
    },
    //初始化 view场景用
    init() {
      //this.costDetailList.push({});
    },
    submitForm (optType) {
      // console.log(this.requestFieldList);
      // console.log(this.responseFieldList);

      if(optType == 'saveFirst'){
        //校验必填
        this.$refs['mainForm'].validate((valid) => {
          if (valid) {

            if(this.initDataForm.costAttach == '00901'){
              if(this.mainForm.costAttachIds == null || this.mainForm.costAttachIds == "" || this.mainForm.costAttachIds == "," ){
                this.$message.warning(this.$t('cost.cost114'));//请上传审核单附件后再提交报销单
                return false;
              }
            }

            if(this.costDetailList == null ||  this.costDetailList.length == 0){
              this.$message.warning(this.$t('cost.cost065'));//请填写报销明细后再提交报销单
              return false;
            }

            for(var i = 0; i < this.costDetailList.length; i++){
              var costDetailBO = this.costDetailList[i];
              if(!costDetailBO.startDate){
                this.$message.warning(this.$t('cost.cost066') + "[" + this.$t('cost.invoice031') + "]" + this.$t('cost.cost067') );//报销明细中[开始日期]不能为空！
                return false;
              }

              if(!costDetailBO.projectName){
                this.$message.warning(this.$t('cost.cost066') + "[" + this.$t('cost.invoice028') + "]" + this.$t('cost.cost067') );//报销明细中[报销项目]不能为空！
                return false;
              }

              if(!costDetailBO.currency){
                this.$message.warning(this.$t('cost.cost066') + "[" + this.$t('cost.invoice035') + "]" + this.$t('cost.cost067') );//报销明细中[币种]不能为空！
                return false;
              }

              if(!costDetailBO.exchangeRate){
                this.$message.warning(this.$t('cost.cost066') + "[" + this.$t('cost.invoice036') + "]" + this.$t('cost.cost067') );//报销明细中[汇率]不能为空！
                return false;
              }

              if(!costDetailBO.fmoney){
                this.$message.warning(this.$t('cost.cost066') + "[" + this.$t('cost.invoice038') + "]" + this.$t('cost.cost067') );//报销明细中[含税金额]必须大于0！
                return false;
              }
            }

            this.doSubmit(optType);

          }else{
            this.$message.warning(this.$t('cost.invoice054'));//请确认必填项信息是否已经完整录入！
          }
        });
      }else{
        this.doSubmit(optType);
      }


    },
    doSubmit(optType){
      // if(this.mainForm.appliIdNew != null && this.userId != this.mainForm.appliIdNew){
      //   for(var i = 0; i < this.touchingPersonList.length; i++){
      //     if(this.touchingPersonList[i].codeItemId == this.mainForm.appliIdNew){
      //       this.mainForm.appliNameNew = this.touchingPersonList[i].codeItemName;
      //     }
      //   }
      // }

      if(this.mainForm.isContractBo){
        isContract
      }
      this.mainForm.saveFlag = optType;
      this.$set(this.mainForm, 'costDetailList', this.costDetailList);

      var hedgebronewList = [];

      if(this.borrowList && this.borrowList.length > 0){
        for(var i = 0; i < this.borrowList.length; i++){
          var hedgebro = parseFloat2Round(this.borrowList[i].hedgebro);
          if(this.borrowList[i]["checked"] && hedgebro > 0){
            hedgebronewList.push({
              hedgebronew : hedgebro,
              idnew : this.borrowList[i].id,
            });
          }
        }
      }

      this.$set(this.mainForm, 'hedgebronewList', hedgebronewList);

      var data = {
        mainForm : this.mainForm
      };

      // if(this.tableDatas == null || this.tableDatas.length == 0){
      //   this.$message.error("请先添加出库商品后再进行操作");
      //   return;
      // }

      this.demoLoading = true;
      saveCostCloud(data)
        .then(res => {
          this.demoLoading = false;
          console.log(saveCostCloud, res.data);
          var code = res.data.code;
          if(code == "0"){
            this.$message.success(this.$t('homepage.txt028')); //操作成功
            var result = res.data.data;
            var returnType = result.returnType;
            if(returnType == "toCostStatusListIndex"){
              //新建任务单场景（提交或者暂存）
              var params = {
                currentTab : '',
              };

              if(optType == "draft"){
                params.currentTab = "draft";
              }

              this.$router.push({path:'/costApplication/costList',query: params});
            }else if(returnType == "toCostStatusList"){
              //编辑任务单场景（提交或者暂存） 根据分页信息 页签名称跳转
              var params = {
                currentTab : '',
              };

              if(optType == "draft"){
                params.currentTab = "draft";
              }

              this.$router.push({path:'/costApplication/costList',query: params});
            }else if(returnType == "preViewCostProcess"){
              //校验异常 或者流程展示
              this.$refs.previewCostProcess.visible = true;
              this.$refs.previewCostProcess.optParams = result;
              this.$refs.previewCostProcess.init();
            }
            // this.doGoBack();
          }else{
            this.$message.error(res.data.msg);
          }
          // let result = res.data;
          // if (result.code == 0) {
          //   this.$message.success('保存成功');
          //   if(this.from == "storageDetailList"){
          //     this.$router.push({path:'/inventory/storageDetailList'});
          //   }else if(this.from == "batchDetailList"){
          //     var optParam = {
          //       itemId: this.itemId,
          //       storageId: this.storageId,
          //       storageName: this.storageName,
          //       from: this.parentFrom,
          //     };
          //     this.$router.push({path:'/inventory/batchDetailList',query: optParam});
          //   }
          // } else {
          //   this.$message.error(result.msg);
          // }
        })
        .catch(error => {
          this.demoLoading = false;
          if(error.data.msg){
            this.$message.error(error.data.msg);
          }else{
            this.$message.error(error);
          }
        })
    },
    applierIdChange(val){
      this.getCloudDeptByPerId(val);

      if (this.mainForm.costType == "30030001") {
        //查询差旅申请单列表
        this.$set(this, "travelApplicationList" , []);
        this.getCloudTravelApplicationList(val);
      }


    },
    costTypeChange(val){
      console.log("costType" , val)
      console.log("costType" , this.mainForm.costType)
      this.$set(this.mainForm, "payeeAccountId", null);

      this.getCloudCostEditInitData(val);

      if(this.mainForm.costType != '30030001'){
        this.$set(this.mainForm, "applicationId", "");
      }else{
        this.$set(this.mainForm, "payeeName", null);
      }
      this.$refs.mainForm.resetFields();

      //初始化支付信息 非供应商支付
      // if(this.mainForm.costType != "30030003"){
      //   var personBO = this.initDataForm.personBO;
      //   if(personBO){
      //     this.$set(this.mainForm, "payeeId", personBO.payeeId);
      //     this.$set(this.mainForm, "payeeLabel", personBO.payeeName ? personBO.payeeName : this.initDataForm.user.name);
      //   }
      //
      //   this.getCloudOrgPersonTree();
      //   this.getCloudJsonAssistProjectList();
      //   this.getCloudCusSupplierForContract();
      // }
    },
    payeeNameChange(val){
      this.$set(this.mainForm, "payeeAccountId", null);
      this.getCloudPayeeAccount(this.mainForm.payeeId, val);
    },
    sourceIdChange(val){
      this.$set(this.mainForm, "payeeAccountId", null);
      this.getCloudCusSupplierPayeeId(val);
    },
    contactChange(){
      if(isvalidatemobile(this.mainForm.contact)[0]){
        this.$message.error(this.$t('cost.cost068'));//请输入正确的联系方式！
        this.$set(this.mainForm, "contact", "");
      }
    },
    supplierIdChange(val){
      console.log("supplierIdChange", val)
      this.$set(this.mainForm, "constractId", null);
      this.$set(this.mainForm, "sourceId", null);
      this.$set(this.mainForm, "payeeId" , null);
      this.$set(this.mainForm, "payeeAccountId", null);
      // this.$refs.mainForm.resetFields();

      this.refreshData(val);
      this.getCloudConstractInfoBySupplierIdAndPersonId(val);
    },
    constractIdChange(val){
      console.log("constractIdChange", val)
      this.refreshData(this.mainForm.supplierId);
      this.getCloudConstractPaymentInfo(val);
    },
    hedgebroChange(row){
      this.$nextTick(function () {
        //校验录入值是否大于此项借款最大值
        var hedgebro = row.hedgebro;
        var remainingAmount = row.remainingAmount;
        if(parseFloat2Round(hedgebro) > parseFloat2Round(remainingAmount)){
          this.$message.error(this.$t('cost.cost069'));//借款冲抵金额不能大于借款金额！
          this.$set(row, "hedgebro", 0);
        }

        //校验冲抵总值是否大于费用总值
        var sumhedgebro = 0;

        if(this.borrowList && this.borrowList.length > 0){
          for(var i = 0; i < this.borrowList.length; i++){
            var borrowBO = this.borrowList[i];
            if(borrowBO["checked"]){
              var hedgebro = borrowBO.hedgebro;
              if (hedgebro != "" && !isNaN(hedgebro)){
                sumhedgebro = accAdd(sumhedgebro, parseFloat2Round(hedgebro));

                if(sumhedgebro > this.totalMoneyAll){
                  this.$message.error(this.$t('cost.cost070'));//借款冲抵金额不能大于费用总金额，请重新输入!！
                  sumhedgebro = Subtr(sumhedgebro, parseFloat2Round(hedgebro));
                  this.$set(row, "hedgebro", 0);
                  break;
                }
              }
            }
          }
        }

        this.calcTotlMoney();
      })


    },
    refreshData(supplierId){
      //更新供应商
      this.getCloudCusSupplierBySupplierId(supplierId);
      //更新payeeid和支付账号列表
      this.getCloudCusSupplierPayeeId(supplierId);
    },
    getCloudCostEditInitData(costType) {
      let params = {
        searchParams : {
          costType: costType,
        }
      }

      getCloudCostEditInitData(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            console.log(result.data, 'result-data')
            //result.data.loanLimitSwitch = "00901";
            this.initDataForm = result.data;
            this.getBorrowColumn();

            //初始化报销类型
            if(!this.mainForm.costType){
              this.mainForm.costType = this.initDataForm.costType;
            }
            if(this.costTypeList.length == 0){
              this.$set(this,"costTypeList", this.initDataForm.costTypeList);
            }

            //初始化支付信息 非供应商支付
            if(this.mainForm.costType != "30030003"){
              var personBO = this.initDataForm.personBO;
              if(personBO){
                this.$set(this.mainForm, "payeeId" , personBO.payeeId);
                this.$set(this.mainForm, "payeeLabel" , personBO.payeeName ? personBO.payeeName : this.initDataForm.user.name);
              }
            }

            this.getCloudOrgPersonTree();
            this.getCloudJsonAssistProjectList();
            this.getCloudCusSupplierForContract();
            this.getCloudCusSupplier();


          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudEditCostInfo(costId, costStatus, costType) {
      let params = {
        searchParams : {
          costId: costId,
          costStatus: costStatus,
          costType: costType,
        }
      }

      getCloudEditCostInfo(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.initDataForm = result.data;
            this.getBorrowColumn();

            //初始化报销类型
            var costInfoBO = result.data.costInfoBO;

            this.$set(costInfoBO, "payeeAccountId" , result.data.payeeAccountBO.id);
            this.$set(costInfoBO, "costId" , costInfoBO.id);
            if(result.data.payeeBO){
              this.$set(costInfoBO, "payeeLabel" , result.data.payeeBO.payeeUnit);
            }
            this.$set(costInfoBO, "costRemark" ,  costInfoBO.remark);
            this.$set(costInfoBO, "custom_item1" , costInfoBO.customItem1);
            this.$set(costInfoBO, "custom_item2" , costInfoBO.customItem2);
            this.$set(costInfoBO, "custom_item3" , costInfoBO.customItem3);
            this.$set(costInfoBO, "custom_item4" , costInfoBO.customItem4);
            this.$set(costInfoBO, "custom_item5" , costInfoBO.customItem5);
            this.$set(costInfoBO, "custom_item6" , costInfoBO.customItem6);
            this.$set(costInfoBO, "custom_item7" , costInfoBO.customItem7);
            this.$set(costInfoBO, "custom_item8" , costInfoBO.customItem8);
            this.$set(costInfoBO, "custom_item9" , costInfoBO.customItem9);
            this.$set(costInfoBO, "editFlag" , this.$route.query.editFlag);

            if(costInfoBO.constractSupplierId){
              this.$set(costInfoBO, "supplierId" , costInfoBO.constractSupplierId);
              this.$set(this, "supplierContractFlag" , true);
            }

            if(costInfoBO.costAttachIds){
              this.$set(this, "costAttachUploadFjUrl", btn_upload_fj_on);
            }
            //this.mainForm.payeeAccountId = result.data.payeeAccountBO.id;

            this.$set(this, "mainForm" , costInfoBO);

            if(costInfoBO.isContract == '00901'){
              this.$set(this, "isContractBoolean", true);
            }

            var costDetailList = result.data.costDetailList;
            for(var i = 0; i < costDetailList.length; i++){
              var costdetail = costDetailList[i];
              costdetail.billNo = costdetail.eInvoiceCode;
              costdetail.detailAttachIds = costdetail.attachIds;
              costdetail.btnDeleteUrl = btn_delete;
              costdetail.btnWarnUrl = btn_warn;

              if(costdetail.attachIds){
                costdetail.btnUploadFjUrl = btn_upload_fj_on;
                costdetail.uploadBtnFlag = true;
              }else{
                costdetail.btnUploadFjUrl = btn_upload_fj;
                costdetail.uploadBtnFlag = false;
              }

              if(costdetail.shareId){
                costdetail.btnShareUrl = btn_share_on;
                costdetail.shareBtnFlag = true;
              }else{
                costdetail.btnShareUrl = btn_share;
                costdetail.shareBtnFlag = false;
              }

            }

            this.costDetailList = result.data.costDetailList;

            if(this.costTypeList.length == 0){
              this.$set(this,"costTypeList", this.initDataForm.costTypeList);
            }

            //初始化支付信息 非供应商支付
            if(this.mainForm.costType != "30030003"){
              var personBO = this.initDataForm.personBO;
              if(personBO && this.mainForm.editFlag == 'add'){
                this.mainForm.payeeId = personBO.payeeId;
                this.mainForm.payeeLabel = personBO.payeeName ? personBO.payeeName : this.initDataForm.user.name;
              }
            }

            this.getCloudOrgPersonTree();
            this.getCloudJsonAssistProjectList();
            this.getCloudCusSupplierForContract();
            this.getCloudCusSupplier();

            if(this.mainForm.costType == "30030003"){
              this.refreshData(costInfoBO.constractSupplierId);
              this.getCloudConstractInfoBySupplierIdAndPersonId(costInfoBO.constractSupplierId);
            }

            this.calcTotlMoney();

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getViewCloudCostInfo(costId, costStatus) {
      let params = {
        searchParams : {
          costId: costId,
          costStatus: costStatus,
        }
      }

      getViewCloudCostInfo(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.initDataForm = result.data;

            //初始化报销类型
            var costInfoBO = result.data.costInfoBO;

            var costTypeBO = {
              COST_TYPE: costInfoBO.costType,
              DEFINED_NAME: costInfoBO.costTypeName,
            };

            this.$set(this.initDataForm, "costTypeList", [costTypeBO]);

            this.$set(costInfoBO, "payeeAccountId" , result.data.payeeAccountBO.id);
            this.$set(costInfoBO, "costId" , costInfoBO.id);
            if(result.data.payeeBO){
              this.$set(costInfoBO, "payeeLabel" , result.data.payeeBO.payeeUnit);
            }
            this.$set(costInfoBO, "costRemark" ,  costInfoBO.remark);
            this.$set(costInfoBO, "custom_item1" , costInfoBO.customItem1);
            this.$set(costInfoBO, "custom_item2" , costInfoBO.customItem2);
            this.$set(costInfoBO, "custom_item3" , costInfoBO.customItem3);
            this.$set(costInfoBO, "custom_item4" , costInfoBO.customItem4);
            this.$set(costInfoBO, "custom_item5" , costInfoBO.customItem5);
            this.$set(costInfoBO, "custom_item6" , costInfoBO.customItem6);
            this.$set(costInfoBO, "custom_item7" , costInfoBO.customItem7);
            this.$set(costInfoBO, "custom_item8" , costInfoBO.customItem8);
            this.$set(costInfoBO, "custom_item9" , costInfoBO.customItem9);
            this.$set(costInfoBO, "editFlag" , this.$route.query.editFlag);
            //this.mainForm.payeeAccountId = result.data.payeeAccountBO.id;
            if(costInfoBO.constractSupplierId){
              this.$set(costInfoBO, "supplierId" , costInfoBO.constractSupplierId);
              this.$set(this, "supplierContractFlag" , true);
            }

            if(costInfoBO.costAttachIds){
              this.$set(this, "costAttachUploadFjUrl", btn_upload_fj_on);
            }

            this.$set(this, "mainForm" , costInfoBO);
            this.$set(this, "costProcessList", result.data.costProcessList);
            this.costProcessNoHisList = result.data.costProcessNoHisList


            var costDetailList = result.data.costDetailList;
            for(var i = 0; i < costDetailList.length; i++){
              var costdetail = costDetailList[i];
              costdetail.billNo = costdetail.eInvoiceCode;
              costdetail.detailAttachIds = costdetail.attachIds;
              costdetail.btnDeleteUrl = btn_delete;
              costdetail.btnWarnUrl = btn_warn;

              if(costdetail.attachIds){
                costdetail.btnUploadFjUrl = btn_upload_fj_on;
                costdetail.uploadBtnFlag = true;
              }else{
                costdetail.btnUploadFjUrl = btn_upload_fj;
                costdetail.uploadBtnFlag = false;
              }

              if(costdetail.shareId){
                costdetail.btnShareUrl = btn_share_on;
                costdetail.shareBtnFlag = true;
              }else{
                costdetail.btnShareUrl = btn_share;
                costdetail.shareBtnFlag = false;
              }
            }

            this.costDetailList = result.data.costDetailList;


            if(this.costTypeList.length == 0){
              this.$set(this,"costTypeList", this.initDataForm.costTypeList);
            }

            //初始化支付信息 非供应商支付
            if(this.mainForm.costType != "30030003"){
              var personBO = this.initDataForm.personBO;
              if(personBO && this.mainForm.editFlag == 'add'){
                this.mainForm.payeeId = personBO.payeeId;
                this.mainForm.payeeLabel = personBO.payeeName ? personBO.payeeName : this.initDataForm.user.name;
              }
            }

            this.getCloudOrgPersonTree();
            this.getCloudJsonAssistProjectList();
            this.getCloudCusSupplierForContract();
            this.getCloudCusSupplier();

            this.calcTotlMoney();

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudOrgPersonTree() {
      let params = {
        searchParams : {
          key: "",
        }
      }

      getCloudOrgPersonTree(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.applierList = result.data.records;
            if(result.data.personExitFlag = "true"){
              if(this.mainForm.editFlag == 'add' &&  this.applierList != null && this.applierList.length == 1){
                // this.mainForm.applierId = result.data.userId;
                this.$set(this.mainForm, "applierId" , result.data.userId);
                this.applierIdChange(this.mainForm.applierId);
              }else if(this.$route.query.editFlag == 'edit' || this.$route.query.editFlag == 'view'){
                this.applierIdChange(this.mainForm.applierId);
              }
            }
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudDeptByPerId(personId) {
      let params = {
        searchParams : {
          personId: personId,
        }
      }

      getCloudDeptByPerId(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudDeptByPerId", result)
          if(result.code == '0'){
            if(this.mainForm.editFlag == 'add'){
              this.$set(this.mainForm, "contact" ,result.data.phone);
              this.$set(this.mainForm, "deptName" ,result.data.deptName);
              this.$set(this.mainForm, "deptId" ,result.data.deptID);

            }

            if(this.mainForm.payeeId && this.mainForm.payeeLabel){

              if(this.mainForm.editFlag == 'add'){
                this.$set(this.mainForm, "payeeId" ,result.data.payeeId);
                this.$set(this.mainForm, "payeeLabel" ,result.data.perName);
              }

              var payeeId = this.mainForm.payeeId;
              if(!payeeId){
                payeeId = "no";
              }

              //处理支付信息
              if(this.mainForm.costType != "30030003"){
                this.getCloudPersonPayee(payeeId);
              }

              //处理借款
              this.getCloudBorrowListByPerId();
              //老代码里面有个逻辑reflashCategory 查询个人预算的类型，但是个人预算表类型字段是空的，应该是个作废的逻辑先不管它
              this.reflashCategory();
            }
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudTravelApplicationList(applerId) {
      let params = {
        searchParams : {
          userId: applerId,
        }
      }

      getCloudTravelApplicationList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudTravelApplicationList", result)
          if(result.code == '0'){
            //todo shipengchao 这里后续调试下下拉列表的显示
            this.$set(this, "travelApplicationList" ,result.data);
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudPersonPayee(payeeId) {
      let params = {
        searchParams : {
          payeeId: payeeId,
        }
      }
      var that = this;
      getCloudPersonPayee(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudPersonPayee", result)
          if(result.code == '0'){
            if(result.data.length > 0){
              result.data.forEach(function(item, index){
                that.$set(item, "codeItemId", item.payeeName);
                that.$set(item, "codeItemName", item.payeeName);
                if(index == 0 && that.mainForm.editFlag == 'add'){
                  that.$set(that.mainForm, "payeeName", item.payeeName);
                }
              });
            }
            this.$set(this, "personPayeeList" ,result.data);

            that.getCloudPayeeAccount(payeeId, that.mainForm.payeeName);

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudPayeeAccount(payeeId, payeeName) {
      let params = {
        searchParams : {
          payeeId: payeeId,
          payeeName: payeeName
        }
      }

      var that = this;
      getCloudPayeeAccount(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudPayeeAccount", result)
          if(result.code == '0'){

            result.data.forEach(function(item, index){
              that.$set(item, "codeItemId", item.id);
              that.$set(item, "codeItemName", item.bankNum);
              if(index == 0 && (that.mainForm.editFlag == 'add' || !that.mainForm.payeeAccountId)){
                that.$set(that.mainForm, "payeeAccountId", item.id);
              }
            });

            this.$set(this, "payeeAccountList" ,result.data);
          }else{
            this.$message.error(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudBorrowListByPerId() {
      this.$set(this, "borrowList", []);
      var borrowType = this.mainForm.costType == '30030003' ? '30500002' : '30500001'; //供应商支付场景下为公司借款
      let params = {
        searchParams : {
          personId: this.mainForm.applierId,
          borrowType: borrowType,
          payeeId: this.mainForm.payeeId,
        }
      }

      var that = this;
      getCloudBorrowListByPerId(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudBorrowListByPerId", result)
          if(result.code == '0'){

            //借款场景
            if(result.data && result.data.length > 0){

              if(this.$route.query.editFlag == 'add' || (this.$route.query.editFlag != 'add' && this.borrowInitFlag == false )){
                this.$set(this, "borrowList", result.data);
                for(var i = 0; i < this.borrowList.length; i++){
                  this.$set(this.borrowList[i], "hedgebro", 0);
                  if(this.initDataForm.loanLimitSwitch == '00901'){
                    this.$set(this.borrowList[i], "checked", true);
                  }
                }
              }else{
                this.borrowInitFlag = true;
                var borrowList = result.data;
                console.log("borrowList", borrowList);
                console.log("this.initDataForm", this.initDataForm);

                var costHedgebroList = this.initDataForm.costHedgebroList;
                var costHedgebroMap = {};
                for(var i=0; i < costHedgebroList.length; i++){
                  this.$set(costHedgebroMap, costHedgebroList[i].broId, parseFloat2Round(costHedgebroList[i].broHedgeMoney));
                }

                for(var i = 0; i < borrowList.length; i++){
                  if(costHedgebroMap[borrowList[i].id]){
                    this.$set(borrowList[i], "hedgebro", costHedgebroMap[borrowList[i].id]);
                    this.$set(borrowList[i], "checked", true);
                  }else{
                    this.$set(borrowList[i], "hedgebro", 0);
                    if(this.initDataForm.loanLimitSwitch == '00901'){
                      this.$set(borrowList[i], "checked", true);
                    }
                  }
                }

                this.$set(this, "borrowList", borrowList);

              }
            }
            this.calcTotlMoney();
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudJsonAssistProjectList() {
      let params = {
        searchParams : {}
      }

      var that = this;
      getCloudJsonAssistProjectList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudJsonAssistProjectList", result)
          result.forEach(function(item, index){
            that.$set(item, "codeItemId", item.ID);
            that.$set(item, "codeItemName", item.proName);
          });

          this.$set(this, "assistProjectList" ,result);
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudCusSupplierForContract() {
      let params = {
        searchParams : {}
      }

      var that = this;
      getCloudCusSupplierForContract(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudCusSupplierForContract", result)
          if(result.code == '0'){

            result.data.forEach(function(item, index){
              that.$set(item, "codeItemId", item.id);
              that.$set(item, "codeItemName", item.name);
            });

            this.$set(this, "cusSupplierForContractList" ,result.data);
          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudCusSupplierBySupplierId(supplierId) {
      let params = {
        searchParams : {
          supplierId : supplierId
        }
      }

      var that = this;
      getCloudCusSupplierBySupplierId(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudCusSupplierBySupplierId", result)
          if(result.code == '0'){

            result.data.forEach(function(item, index){
              that.$set(item, "codeItemId", item.id);
              that.$set(item, "codeItemName", item.name);
              if(index == 0 && !that.mainForm.sourceId){
                that.$set(that.mainForm, "sourceId", item.id);
              }
            });

            this.$set(this, "sourceIdList" ,result.data);

          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudCusSupplierPayeeId(supplierId) {
      if(!supplierId){
        return;
      }

      let params = {
        searchParams : {
          sourceId : supplierId
        }
      }

      var that = this;
      getCloudCusSupplierPayeeId(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudCusSupplierPayeeId", result)
          if(result.code == '0'){
            // if(!that.mainForm.payeeId){
              var payeeId = result.data;
              that.$set(that.mainForm, "payeeId" , payeeId);
              that.getCloudPayeeAccount(payeeId, null);
            // }

          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudConstractInfoBySupplierIdAndPersonId(supplierId) {
      let params = {
        searchParams : {
          supplierId : supplierId
        }
      }

      var that = this;
      getCloudConstractInfoBySupplierIdAndPersonId(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudConstractInfoBySupplierIdAndPersonId", result)
          if(result.code == '0'){
            var flag = result.data;
            if(flag == "true"){
              that.supplierContractFlag = true;
              that.getCloudConstractInfoBySupplierId(supplierId);
            }else{
              that.supplierContractFlag = false;
              that.$set(that.mainForm, "constractId", null);
              that.$set(that.mainForm, "invoiceDate", null);
              that.contractInfo = {};
            }

          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudConstractInfoBySupplierId(supplierId) {
      let params = {
        searchParams : {
          supplierId : supplierId
        }
      }

      var that = this;
      getCloudConstractInfoBySupplierId(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudConstractInfoBySupplierId", result)
          if(result.code == '0'){

            result.data.forEach(function(item, index){
              that.$set(item, "codeItemId", item.id);
              that.$set(item, "codeItemName", item.contractNo);
              if(index == 0 && !that.mainForm.constractId){
                that.$set(that.mainForm, "constractId", item.id);
                that.getCloudConstractPaymentInfo(item.id);
              }
            });

            this.$set(this, "constractIdList" ,result.data);
          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudConstractPaymentInfo(constractId) {
      let params = {
        searchParams : {
          constractId : constractId
        }
      }
      this.contractInfo = {};

      var that = this;
      getCloudConstractPaymentInfo(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudConstractPaymentInfo", result)
          if(result.code == '0'){
            this.contractInfo = result.data;
            //todo shipengchao 这里需要显示合同信息
          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    getCloudCusSupplier() {
      let params = {
        searchParams : {
        }
      }

      var that = this;
      getCloudCusSupplier(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          console.log("getCloudCusSupplier", result)
          if(result.code == '0'){

            result.data.forEach(function(item, index){
              that.$set(item, "codeItemId", item.id);
              that.$set(item, "codeItemName", item.name);
            });

            this.$set(this, "sourceIdList" ,result.data);
          }else{
            this.$message.success(result.msg);
          }

        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    pickInvoiceSubmit(pickList){
      console.log("pickInvoiceSubmitAddDetail:" , pickList);
      for(var i = 0; i < pickList.length; i++){
        var pickBO = { ...pickList[i] };
        pickBO.vatType = pickBO.invoiceType;
        pickBO.vatTypeName = pickBO.invoiceTypeTxt;
        pickBO.billNo = pickBO.invoiceHm;
        pickBO.detailSourceId = pickBO.invoiceId;
        pickBO.detailSourceAttachId = pickBO.attachId;
        pickBO.detailAttachIds = pickBO.attachId;
        pickBO.detailSource = '80320003';
        pickBO.isInvoiceFolder = '00901';
        pickBO.invoiceFolderId = pickBO.id;
        pickBO.id = "";

        if(!pickBO.currency){
          pickBO.currency = "10091001";
          pickBO.currencyTxt = "人民币";
        }

        if(pickBO.currency == "10091001"){
          pickBO.fmoney = pickBO.includeTax;
        }

        pickBO.warnMsg = pickBO.msg;
        pickBO.btnDeleteUrl = btn_delete;
        pickBO.btnShareUrl = btn_share;
        pickBO.btnUploadFjUrl = btn_upload_fj;
        pickBO.btnWarnUrl = btn_warn;

        pickBO.uploadBtnFlag = 'true';
        this.$set(pickBO, "btnUploadFjUrl",btn_upload_fj_on);
//todo shipengchao 关注一下 addCostRowByOcr 这个方法的最后几行



        if(!pickBO.exchangeRate){
          pickBO.exchangeRate = "1";
        }

        this.costDetailList.push(pickBO);
      }

      this.calcTotlMoney();
    },
    previewCostProcessSubmit(){
      console.log("previewCostProcessSubmit")
      this.submitForm("save");
    },
    autoInputLoanMoney(){
      //自动计算借款抵冲
    },
    calcTotlMoney(){
      //计算报销总额
      var sum = 0;

      if(this.costDetailList && this.costDetailList.length > 0){
        for(var i = 0; i < this.costDetailList.length; i++){
          var costDetail = this.costDetailList[i];
          var includeTax = costDetail.includeTax;

          if (includeTax != "" && !isNaN(includeTax)){
            sum = accAdd(sum, parseFloat2Round(includeTax));
          }
        }
      }

      this.totalMoneyAll = parseFloat2Round(sum);

      //强制抵冲场景下，自动计算借款抵冲
      if(this.initDataForm.loanLimitSwitch == '00901' && sum > 0 && this.borrowList && this.borrowList.length > 0){
        var usefullSum = sum;
        for(var i = 0; i < this.borrowList.length; i++){
          var remainingAmount = parseFloat2Round(this.borrowList[i].remainingAmount);
          if(usefullSum <= 0){
            break;
          }else if(remainingAmount <= usefullSum){
            this.$set(this.borrowList[i], "hedgebro", remainingAmount);
            usefullSum = parseFloat2Round(Subtr(usefullSum, remainingAmount));
          }else if(remainingAmount > usefullSum){
            this.$set(this.borrowList[i], "hedgebro", usefullSum);
            usefullSum = 0;
            break;
          }
        }
      }
      console.log(this.borrowList)

      //计算借款
      var sumhedgebro = 0;

      if(this.borrowList && this.borrowList.length > 0){
        for(var i = 0; i < this.borrowList.length; i++){
          var borrowBO = this.borrowList[i];
          if(borrowBO["checked"]){
            var hedgebro = borrowBO.hedgebro;
            if (hedgebro != "" && !isNaN(hedgebro)){
              sumhedgebro = parseFloat2Round(accAdd(sumhedgebro, parseFloat2Round(hedgebro)));

              if(sumhedgebro > sum){
                this.$message.error(this.$t('cost.cost070'));//借款冲抵金额不能大于费用总金额，请重新输入！
                sumhedgebro = Subtr(sumhedgebro, parseFloat2Round(hedgebro));
                this.$set(this.borrowList[i], "hedgebro", 0);
                // console.log(this.borrowList[i].hedgebro)
                //break;
              }
            }
          }
        }
      }

      this.totalBorrowMoney = parseFloat2Round(sumhedgebro);

      //付款金额（报销总额 - 抵扣）
      this.totalMoneyLower = parseFloat2Round(sum - sumhedgebro);

    },
    calcTotlMoneyAll(){
      //计算报销金额
    },
    loanMoney(){
      //计算借款
    },
    reflashCategory(){
      //可能是废逻辑 先空着
    },
    receiptTypeChange(val) {

    },
    handleGoBack(){
      const that = this;
      if(this.optType != 'view'){
        this.$confirm(
          this.$t("cost.invoice059"), //是否放弃当前操作
          this.$t("homepage.txt017"), //提示
          {
            type: 'warning'
          }
        ).then(function(){
          //确认操作
          // if(that.from == "storageDetailList"){
          //   that.$router.push({path:'/inventory/storageDetailList'});
          // }else if(that.from == "batchDetailList"){
          //   var optParam = {
          //     itemId: that.itemId,
          //     storageId: that.storageId,
          //     storageName: that.storageName,
          //     from: that.parentFrom,
          //   };
          //   that.$router.push({path:'/inventory/batchDetailList',query: optParam});
          // }
          that.doGoBack();
        }).then((data) => {
          //取消操作
        }).catch(function (err) {
          //捕获异常
        });
      }else{
        this.doGoBack();
      }
    },
    doGoBack(){
      // if(this.from == "platform"){
      //   this.$router.push({path:'/index'});
      // }else if(this.from == "glCusList"){
      //   this.$router.push({path:'/taskDispatch/glCusList'});
      // } else if (this.from == 'backendList') {
      //   this.$router.go(-1)
      // } else{
      //   var param = {
      //     beCreateFlag : this.$route.query.beCreateFlag,
      //     pagerConfig : this.$route.query.pagerConfig,
      //     searchForm : this.$route.query.searchForm
      //   }
      //   //console.log("goback");
      //   //console.log(param);
      //   this.$router.push({path:'/taskDispatch/taskList', query: param});
      // }

      this.$router.push({path:'/costApplication/costList'});
    },
    pickInvoice(){
      const invoiceFolderIdArr = this.costDetailList.map(item => item.invoiceFolderId);
      const notInIds = validatenull(invoiceFolderIdArr) ? '' : invoiceFolderIdArr.join(',')
      let params = {
        type:"cost",
        notInIds: notInIds,
      }
      this.$refs.pickInvoice.visible = true;
      this.$refs.pickInvoice.optParams = params;
      this.$refs.pickInvoice.init();
    },
    deleteCostDetail(obj, index){
      var that = this;
      this.$confirm(this.$t('cost.cost071'), this.$t("homepage.txt017"), { // 您确定要删除此项报销记录?  提示
        confirmButtonText: this.$t("homepage.txt018"), //确认
        cancelButtonText: this.$t("homepage.txt019"), //取消
        type: 'warning'
      }).then(() => {
        that.costDetailList.splice(index, 1);
        that.calcTotlMoney();
      }).catch(() => {
      });
    },
    showWarn(obj, index){
      Message({
        showClose:true,
        duration: 5000,
        dangerouslyUseHTMLString: true,
        message: obj.warnMsg,
        type: "warning",
      });
    },
    accountManage(){

      // newUrl=basePath+"/baseInfo/bankListIndex.action?CID="+payeeId.base64Encode()+"&from="+"cost".base64Encode();
      var url = "/baseInfo/bankListIndex.action?CID=" + base64Encode(this.mainForm.payeeId) + "&from=" + base64Encode("cost");
      //var url = "http://192.168.203.34:8081/omsRedirect?req=eyJlbmNyeXB0IjoidDUrMmxRcEtnOWlnMmVXSmtUdmVZN2R3L2xabTBZOUhLVnhKSzZWbEFYN0owZmNpVkgyd1IxUkFOTnFWcEFEQjZYaWdlb3h6NTNoZER4MnZMQkV2OFE9PSIsIml2Ijp7IndvcmRzIjpbMjY2MzQ0NzUzNiw5NDE2NTI0NTcsMzQ1NjQwOTE3NCwzMjgwNDQxODM0XSwic2lnQnl0ZXMiOjE2fX0="
      let params = {
        title: this.$t('cost.cost039'),
        url: url,
      }

      this.$refs.DialogIframe.visible = true;
      this.$refs.DialogIframe.optParams = params;
      this.$refs.DialogIframe.init();
    },
    MM_swapImage(obj, imageType, opt){ // v3.0
      return;
      if (obj != null)
      {
        if(imageType == "delete"){
          if(obj.deleteBtnFlag){
            return;
          }
          if(opt == "enter"){
            this.$set(obj, "btnDeleteUrl", btn_delete_on);
          }else{
            this.$set(obj, "btnDeleteUrl", btn_delete);
          }
        }else if(imageType == "share"){
          if(obj.shareBtnFlag){
            return;
          }
          if(opt == "enter"){
            this.$set(obj, "btnShareUrl", btn_share_on);
          }else{
            this.$set(obj, "btnShareUrl", btn_share);
          }
        }else if(imageType == "upload"){
          if(obj.uploadBtnFlag){
            return;
          }
          if(opt == "enter"){
            this.$set(obj, "btnUploadFjUrl", btn_upload_fj_on);
          }else{
            this.$set(obj, "btnUploadFjUrl", btn_upload_fj);
          }
        }
      }
    },
    selectProject(detailBO, index){
      let params = {
        commonProjectList: this.initDataForm.commonProjectList,
        projectTypeList: this.initDataForm.projectTypeList,
        allProjectTypeList : this.initDataForm.allProjectTypeList,
        projectId : detailBO.projectId,
        costType : this.mainForm.costType,
        projectType : detailBO.projectType,
      }
      //detailAttachIds 现有附件
      //detailSourceAttachId 不能删除的附件
      this.activeDetail = detailBO;
      this.$refs.projectSelect.visible = true;
      this.$refs.projectSelect.optParams = params;
      this.$refs.projectSelect.init();
    },
    shareCostDetail(detailBO, index){
      console.log("shareCostDetail", detailBO);
      let optParams = {
        shareId: detailBO.shareId,
        amount: detailBO.includeTax,
        vatMoney: detailBO.vatMoney,
        eVatMoney: detailBO.excludeTax,
        vatType: detailBO.vatType,
        projectId: detailBO.projectId,
        applierId: this.mainForm.applierId,
        editFlag: this.mainForm.editFlag,
      }

      if(detailBO.vatType== '10420005' ||  detailBO.excludeTax){
        //专票
        optParams.vatType = '00901'
        optParams.amount = detailBO.excludeTax;
      }else{
        optParams.vatType = '00900'
      }

      this.activeDetail = detailBO;
      this.$refs.ShareInfo.visible = true;
      this.$refs.ShareInfo.optParams = optParams;
      this.$refs.ShareInfo.init();
    },
    uploadAttachCostDetail(detailBO, index){
      let params = {
        batchId: null,
        btnType: "",
        detailAttachIds: detailBO.detailAttachIds,
        detailSourceAttachId: detailBO.detailSourceAttachId,
        type: "costDetail",
        editFlag: this.mainForm.editFlag,
      }
      //detailAttachIds 现有附件
      //detailSourceAttachId 不能删除的附件
      this.activeDetail = detailBO;
      this.$refs.uploadAttach.visible = true;
      this.$refs.uploadAttach.params = params;
      this.$refs.uploadAttach.init();
    },
    uploadCostAttach(){
      let params = {
        batchId: null,
        btnType: "",
        detailAttachIds: this.mainForm.costAttachIds,
        type: "costDetail",
        editFlag: this.mainForm.editFlag,
      }
      //detailAttachIds 现有附件
      //detailSourceAttachId 不能删除的附件
      this.$refs.uploadCostAttach.visible = true;
      this.$refs.uploadCostAttach.params = params;
      this.$refs.uploadCostAttach.init();
    },
    deleteCostAttach(){
      this.mainForm.costAttachIds = "";
      //修改按钮为灰色
      this.$set(this, "costAttachUploadFjUrl", btn_upload_fj);
    },
    doUploadCostSubmit(fileList) {
      console.log("doUploadCostSubmit", fileList);
      var ids = "";
      if(fileList != null && fileList.length > 0){
        for(var i = 0 ; i < fileList.length; i++){
          ids += fileList[i].attachmentId + ",";
        }
        //修改按钮为亮的
        this.$set(this, "costAttachUploadFjUrl", btn_upload_fj_on);

      }else{
        //修改按钮为灰色
        this.$set(this, "costAttachUploadFjUrl", btn_upload_fj);
      }
      this.mainForm.costAttachIds = ids;
    },
    doUploadSubmit(fileList) {
      console.log("doUploadSubmit", fileList);
      var ids = "";
      if(fileList != null){
        for(var i = 0 ; i < fileList.length; i++){
          ids += fileList[i].attachmentId + ",";
        }
      }
      this.activeDetail.detailAttachIds = ids;
    },
    doShareSubmit(shareId){

      if(shareId == "del"){
        this.activeDetail.shareId = "";
        this.activeDetail.shareBtnFlag = false;
        this.$set(this.activeDetail, "btnShareUrl", btn_share);
      }else{
        this.activeDetail.shareId = shareId;
        this.activeDetail.shareBtnFlag = true;
        this.$set(this.activeDetail, "btnShareUrl", btn_share_on);
      }

    },
    doProjectSubmit(projectBO){

      this.$set(this.activeDetail, "projectId", projectBO.projectId);
      this.$set(this.activeDetail, "projectName", projectBO.projectName);
      this.$set(this.activeDetail, "projectType", projectBO.projectType);
    },
    doDialogIframeClose(){
      if(this.mainForm.costType == '30030003'){
        this.getCloudPayeeAccount(this.mainForm.payeeId, null);
      }else{
        //this.getCloudPayeeAccount(this.mainForm.payeeId, this.mainForm.payeeName);
        this.getCloudPersonPayee(this.mainForm.payeeId);
      }
    },
    viewConstract(){
        window.open(this.preUrl + '/contract/contractAction_toViewContractBillIndex.action?contractId='+ base64Encode(this.mainForm.constractId) + '&subType=' + base64Encode('60060004') + '&' + this.parmStr, '_blank')
    },
    // 上传前处理
    beforeUpload(file) {
      if(this.mainForm.receiptType == null || this.mainForm.receiptType == ''){
        this.$message.error(this.$t("cost.invoice060"));//请先选择票据类型再上传附件!
        return false;
      }

      const isLt20M = file.size / 1024 / 1024 < 20;
      if (file.size <= 0){
        this.$message.error(this.$t("cost.invoice061")); //导入文件为空，请重新选择正确的文件上传!
        return false;
      }
      if (!isLt20M) {
        this.$message.error(this.$t("cost.invoice062") + ' 20MB!'); //上传文件大小不能超过
        // this.$Loading.close();
        return isLt20M;
      }
      // this.$Loading.full();
      return true;
    },
    // 上传文件
    fileChange(file) {

      let _this = this
      let fileName = file.file.name
      let reader = new FileReader();
      reader.readAsDataURL(file.file);
      reader.onload = function() {
        let base64Str = this.result;
        let startNum = (base64Str.indexOf("base64,")) * 1 + 7;
        let baseStr = base64Str.slice(startNum);

        let params = {
          mainForm : {
            fileName : fileName,
            baseStr : baseStr,
          }
        }

        uploadFile(params)
          .then((response) => {
            this.demoLoading = false;
            let result = response.data;
            if(result.code == '0'){
              _this.invoiceFile = result.data;
              //_this.fileListRefresh.push(result.data); //没有实质的用处，解决页面不刷新
            }else{
              this.$message.success(result.msg);
            }
          })
          .catch(error => {
            this.demoLoading = false;
            console.log("error", error)
            this.$message.error(this.$t('homepage.txt024'));//请求异常！
          });

        // fileList.push({
        //   fileName : fileName,
        //   baseStr : baseStr
        // });
        // _this.fileListRefresh.push({fileName:fileName}); //没有实质的用处，解决页面不刷新
      }
    },
    deleteImg(index){
      var that = this;
      this.$confirm(this.$t('homepage.txt022')+'“'+ that.invoiceFile.fileName+'”?', this.$t("homepage.txt017"), { //您确定要删除文件  提示
        confirmButtonText: this.$t("homepage.txt018"), //确认
        cancelButtonText: this.$t("homepage.txt019"),//取消
        type: 'warning'
      }).then(() => {
        this.invoiceFile = {attachmentId: ''};
        //that.fileListRefresh.push({fileName:index})
      }).catch(() => {
      });
    },
    download(file){
      this.demoLoading = true;
      let params = {
        mainForm : {attachmentId : file.attachmentId}
      }

      downloadQiniuFile(params)
        .then((res) => {
          this.demoLoading = false;
          downloadFile(res);
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },
    viewFile(file){
      window.open('/api/sys/viewAttachFile?fileId='+ file.attachmentId, '_blank')
    },
    //===============================上面是有用的==============================
    formItemFocus(){

    },
    //获取请求筛选数据/分页
    tableRefresh(filter, cal) {
      this.filtersData = filter;
      this.pagerConfig.page = filter.page;
      this.pagerConfig.limit = filter.limit;
      //this.getData(cal);
    },
    updateColumn(columns) {
      //console.log(columns);
    },
    selectAllEvent({ checked, records, selection }) {
      this.multipleSelection = records;

      if(this.multipleSelection && this.multipleSelection.length > 0){
        for(var i = 0; i < this.multipleSelection.length; i++){
          this.$set(this.multipleSelection[i], "checked", checked);
        }
      }

      this.changeChecked();
    },
    selectChangeEvent({ checked, records, row }) {
      this.multipleSelection = records;

      this.$set(row, "checked", checked);

      this.changeChecked();
    },
    changeChecked() {
      if(this.borrowList && this.borrowList.length > 0){
        for(var i = 0; i < this.borrowList.length; i++){
          if(!this.borrowList[i]["checked"]){
            this.$set(this.borrowList[i], "hedgebro", 0);
          }
        }
      }

      this.calcTotlMoney();
    },
    // 禁用表格复选框
    checkboxMethod({row}) {
      return true;
      //return row.discernStatus == '80130003';
    },
    toBatchInboundDetail(){
      this.optParam = {
        storageId: this.storageId,
        storageName: this.storageName,
        opt: "add",
        itemList: this.itemList,
        itemMap: this.itemMap,
        batchType:"out",
      };
      this.$refs.batchOutboundDetail.visible = true;
      this.$refs.batchOutboundDetail.optParam = this.optParam;
      this.$refs.batchOutboundDetail.init();
    },
    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts'])
  }
};
</script>

<style lang="scss">
  .approval-tree {
    padding: 20px;
    background-color: #fafafa;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    margin-bottom: 20px;
  }
  .el-collapse-item__header{
    background-color : #f1f1f1;
    padding-left : 5%;
  }
  .content {
    padding: 20px;
    height: 200px; /* 每个内容块的高度 */
    border: 1px solid #ccc;
  }
  .costDetailRow {
    border-right: 1px solid rgba(204, 204, 204, 0.5);
  }
  .costDetailHeader{
    border-top: 1px solid rgba(204, 204, 204, 0.5);
    border-bottom: 1px solid rgba(204, 204, 204, 0.5);
    border-left: 1px solid rgba(204, 204, 204, 0.5);
    text-align: center;
    background-color: #eee;
    font-weight: bold;
  }
  .costDetailCol{
    border-bottom: 1px solid rgba(204, 204, 204, 0.5);
    border-left: 1px solid rgba(204, 204, 204, 0.5);
    text-align: center;
    height: 28px;
  }
  .el-input--suffix .el-input__inner {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
</style>
